import React from "react";
import Box from "components/UI/Box";
import Button from "components/UI/Button";
import Input from "components/UI/Input";
import "./style.css";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL, ERROR_HANDLE, DOWNLOAD } from "config/constants";
import Select from "react-select";

class Chain extends React.Component {
  state = {
    name: "",
    email: "",
    phone: "",
    notes: ""
  };
  getChainList() {
    const access_token = localStorage.getItem("access_token");
    axios
      .get(
        `${API_URL}/admin/chains`,

        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        this.setState({
          ...this.state,
          chains: res.data.map(chain => ({
            value: chain.id,
            label: chain.name
          }))
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }
  selectChain = selectedItem => {
    const chain_id = selectedItem.value;
    if (chain_id) {
      this.setState({ chain_id });
    } else {
      this.setState({ chain_id: "" });
    }
  };
  submitChain = () => {
    const files = document.getElementById("csvInput").files;
    if (files.length) {
      const { name, email, phone, notes,chain_id } = this.state;
      const access_token = localStorage.getItem("access_token");

      const data = new FormData();
      if(this.state.chain_id){
        data.append("chain_id", chain_id);
        data.append("csv", files[0]);
      }
      else{
        data.append("csv", files[0]);
        data.append("name", name);
        data.append("email", email);
        data.append("phone", phone);
        data.append("notes", notes);
      }
      const toastId = toast("Adding Chain...");
      axios
        .post(`${API_URL}/gyms/chains/register`, data, {
          headers: {
            "x-access-token": access_token
          }
        })
        .then(res => {
          toast.dismiss(toastId);
          toast(res.data.message, { autoClose: 2500 });
        })
        .catch(err => {
          toast.dismiss(toastId);
          ERROR_HANDLE(err);
        });
    } else toast("Choose CSV", { autoClose: 1500 });
  };
  getSampleCSV = () => {
    const access_token = localStorage.getItem("access_token");
    axios
      .get(`${API_URL}/admin/documents/chain_onboarding_sample.csv`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "chain_onboarding_sample.csv");
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };
  change(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  componentDidMount(){
    this.getChainList();
  }
  render() {
    return (
      <div>
        <div className="div_ChainSectionWrapper">
          <p className="p_SectionHeader">Chain</p>
          <Box outline>
            <div className="div_OnboardingChain_BoxInner">
              <div className="div_OnboardingChain_Box_Item">
                <Input
                  type="text"
                  placeholder="Name  (Required)"
                  name="name"
                  value={this.state.name}
                  onChange={this.change.bind(this)}
                />
                <Input
                  type="text"
                  placeholder="Email  (Required)"
                  name="email"
                  value={this.state.email}
                  onChange={this.change.bind(this)}
                />
                <Input
                  type="text"
                  placeholder="Phone  (Required)"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.change.bind(this)}
                />
                <p>Or</p>
                <Select
                placeholder="Choose An Existing Chain"
                options={this.state.chains}
                isMulti={false}
                onChange={this.selectChain}
                />
                <div style={{ textAlign: "left", paddingTop: "1rem" }}>
                  Upload CSV: &nbsp;
                  <input
                    style={{ borderBottom: "none" }}
                    type="file"
                    id="csvInput"
                    onChange={this.CSVSelected}
                  />
                </div>
                <Button
                  onClick={this.getSampleCSV}
                  style={{ backgroundColor: "var(--primary)" }}
                >
                  Download Sample CSV
                </Button>
              </div>
              <div className="div_OnboardingChain_Box_Item">
                <p style={{ textAlign: "left" }}>Record notes below. </p>
                <textarea
                  placeholder="Type here..."
                  id="chain_DataEntryNote"
                  name="notes"
                  value={this.state.notes}
                  onChange={this.change.bind(this)}
                />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ width: "200px", marginTop: "10px" }}>
                    <Button
                      style={{ fontSize: "16px" }}
                      type="primary"
                      onClick={this.submitChain}
                    >
                      Send
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>

        {/* <ModalOverlay header="Facility"><AddFacilityModal></AddFacilityModal></ModalOverlay> */}
        {/* <ModalOverlay header="Facility 01"><ViewFacilityModal/></ModalOverlay> */}
      </div>
    );
  }
}

export default Chain;
